/**
 * Typed error variants for the frontend.
 * Discriminated union on 'type' field.
 */

export type ApiError =
  | { readonly type: 'NETWORK_ERROR'; readonly message: string }
  | { readonly type: 'AUTH_ERROR'; readonly message: string }
  | { readonly type: 'VALIDATION_ERROR'; readonly message: string; readonly fields: Record<string, string> }
  | { readonly type: 'NOT_FOUND'; readonly message: string }
  | { readonly type: 'SERVER_ERROR'; readonly message: string; readonly statusCode: number }
  | { readonly type: 'UNKNOWN_ERROR'; readonly message: string }

export function networkError(message: string): ApiError {
  return { type: 'NETWORK_ERROR', message }
}

export function authError(message: string): ApiError {
  return { type: 'AUTH_ERROR', message }
}

export function validationError(message: string, fields: Record<string, string> = {}): ApiError {
  return { type: 'VALIDATION_ERROR', message, fields }
}

export function notFoundError(message: string): ApiError {
  return { type: 'NOT_FOUND', message }
}

export function serverError(message: string, statusCode: number): ApiError {
  return { type: 'SERVER_ERROR', message, statusCode }
}

export function unknownError(message: string): ApiError {
  return { type: 'UNKNOWN_ERROR', message }
}
